import { bl_dgmkt_project_ext_RowClass } from '../../../dbschema/bl_dgmkt_project_ext.model';
import { BaseContainerModel } from '../../base-container.model';

export class DgMktProjectExtensionContainerModel extends BaseContainerModel {
  bl_dgmkt_project_ext: bl_dgmkt_project_ext_RowClass = new bl_dgmkt_project_ext_RowClass();
}
